module.exports = __webpack_public_path__ + "static/media/cube-min.72d0c200.jpg";